export default __webpack_public_path__ + "static/media/20.8df23db6.mp3";